import React, { FC, useEffect, useState } from 'react';
import { IStudent } from '../../../../models/students.model';
import StudentName from '../Name';
import SelectStudentClass from '../SelectStudentClass';
import { Table, TableColumnsType } from 'antd';
import { useTranslation } from 'react-i18next';
import { getCommonCodeLabel } from '../../../../lib/store';
import moment from 'moment';
import Pagination from '../../../Pagination';
import { useGetStudentHistoriesBooksQuery } from '../../../../api/books/bookManagement.api';
import useAxios from '../../../../hooks/useAxios';
import { IGetStudentClasses } from '../../../../models/studentsClass.model';
import { getStudentClasses } from '../../../../api/studentsClass.api';

interface IProps {
  student: IStudent | undefined;
}

const BookTab: FC<IProps> = ({ student }) => {
  const { t, i18n } = useTranslation();

  const [classCode, setClassCode] = useState<string>();
  const [page, setPage] = useState(1);
  const [searchData, setSearchData] = useState({
    classCode,
    studentCode: '',
    page,
    pageSize: 15,
  });
  const { data: responseData, isFetching } = useGetStudentHistoriesBooksQuery(
    searchData,
    { skip: !searchData.classCode && !searchData?.studentCode },
  );
  const {
    data: res2,
    isLoading: isLoading2,
    execute: execute2,
  } = useAxios<IGetStudentClasses>();
  const histories = responseData?.data;
  const historyBooksColumn: TableColumnsType<object> = [
    {
      title: 'No',
      dataIndex: 'no',
      align: 'center',
      width: 80,
    },
    {
      title: t('student.student.68'),
      dataIndex: 'bookName',
      align: 'center',
      width: 220,
      ellipsis: true,
      render : (value) => {
        return (<div className="text-left ant-table-cell-ellipsis">{value}</div>)
      }
    },
    {
      title: 'ISBN',
      dataIndex: 'isbn',
      align: 'center',
    },
    {
      title: t('student.student.69'),
      dataIndex: 'bookSeq',
      align: 'center',
      width: 80,
      render: (value: number) => (value ? value : '-'),
    },
    {
      title: t('student.student.70'),
      dataIndex: 'lendingDate',
      align: 'center',
      render: (value) => {
        return value ? moment(value).format('YYYY-MM-DD') : '-';
      },
    },
    {
      title: t('student.student.71'),
      dataIndex: 'lendingStatus',
      align: 'center',
      render: (value, record: any) => {
        return ['RT', 'DR'].includes(value) ? (
          value === 'DR' ? (
            <span style={{ color: 'red' }}>
              {getCommonCodeLabel('BK0003', value, i18n.language)}
            </span>
          ) : (
            getCommonCodeLabel('BK0003', value, i18n.language)
          )
        ) : record?.overdueDay ? (
          <>
            {getCommonCodeLabel('BK0003', value, i18n.language)}
            <span style={{ color: 'red' }}>
              ({record?.overdueDay}
              {t('student.student.72')})
            </span>
          </>
        ) : (
          getCommonCodeLabel('BK0003', value, i18n.language)
        );
      },
    },
  ];

  useEffect(() => {
    if (!classCode) return;

    setSearchData({ ...searchData, page: 1, classCode });
    setPage(1);
  }, [classCode]);

  useEffect(() => {
    if (!student?.studentCode) return;

    setSearchData({ ...searchData, page, studentCode: student.studentCode });
  }, [student?.studentCode]);

  useEffect(() => {
    if (!student?.studentCode) return;

    execute2(getStudentClasses(student?.studentCode));
  }, [student?.studentCode]);

  useEffect(() => {
    if (res2 && !isLoading2) {
      const _classes = res2.data?.filter(
        (item) => item.studyStatus === 'RE' || item.studyStatus === 'PL',
      );
      const currentClass = _classes?.find((item) => item.studyStatus === 'RE');

      if (currentClass) {
        setClassCode(currentClass.classCode);
      }
    }
  }, [res2, isLoading2]);

  return (
    <>
      <StudentName student={student} />

      <div className="comm-bx__space">
        <div className='comm-btn__area right'>
          <div className='w-240p'>
            <SelectStudentClass
              memberCode={student?.studentCode}
              classCode={classCode}
              setClassCode={setClassCode}
              isAll={true}
            />
          </div>
        </div>
      </div>
      <Table
        className='comm-table__area'
        columns={historyBooksColumn}
        dataSource={histories?.copyBooksDtos ?? []}
        loading={isFetching}
        pagination={{
          current: page,
          pageSize: searchData.pageSize,
        }}
      />
      <div className="comm-bx__between">
        <div className="common-paging center">
          <Pagination
            count={histories?.totalCount}
            page={page}
            perPage={searchData.pageSize}
            setPage={setPage}
          />
        </div>
      </div>
    </>
  );
};

export default BookTab;
